/**
 * Cross-store checkout: black cart drawer → white cart permalink.
 * Maps black variant IDs to white variant IDs (same options) and redirects.
 *
 * Para rotacionar o tráfego entre lojas white, altere só ACTIVE_WHITE.
 * Para adicionar uma nova loja, inclua uma entrada em WHITE_STORES.
 */
(function () {
  'use strict';

  // Troque só esta constante para rotacionar o tráfego:
  var ACTIVE_WHITE = 'white1';

  var WHITE_STORES = {
    white1: {
      domain: 'https://yhg4in-ha.myshopify.com',
      variants: {
        // f-home-jersey-2026
        51547079016743: 53976038736210, // Home - Blue, XS
        51547079835943: 53976038768978, // Home - Blue, S
        51547079868711: 53976038801746, // Home - Blue, M
        51547079901479: 53976038834514, // Home - Blue, L
        51547079934247: 53976038867282, // Home - Blue, XL
        51547079967015: 53976038900050, // Home - Blue, 2XL
        51547079999783: 53976038932818, // Home - Blue, 3XL
        51547079049511: 53976038965586, // Away - Green, XS
        51547080032551: 53976038998354, // Away - Green, S
        51547080065319: 53976039031122, // Away - Green, M
        51547080098087: 53976039063890, // Away - Green, L
        51547080130855: 53976039096658, // Away - Green, XL
        51547080163623: 53976039129426, // Away - Green, 2XL
        51547080196391: 53976039162194, // Away - Green, 3XL

        // spain-shirt
        51650042069287: 54010086228306, // Roja y Azul / XS
        51650042102055: 54010086261074, // Roja y Azul / S
        51650042134823: 54010086293842, // Roja y Azul / M
        51650042167591: 54010086326610, // Roja y Azul / L
        51650042200359: 54010086359378, // Roja y Azul / XL
        51650042233127: 54010086392146, // Roja y Azul / 2XL
        51650042265895: 54010086424914, // Roja y Azul / 3XL
        51650042298663: 54010086457682, // Blanca / XS
        51650042331431: 54010086490450, // Blanca / S
        51650042364199: 54010086523218, // Blanca / M
        51650042396967: 54010086555986, // Blanca / L
        51650042429735: 54010086588754, // Blanca / XL
        51650042462503: 54010086621522, // Blanca / 2XL
        51650042495271: 54010086654290, // Blanca / 3XL
        51650386428199: 54010090750290, // Vino / XS
        51650386460967: 54010090783058, // Vino / S
        51650386493735: 54010090815826, // Vino / M
        51650386526503: 54010090848594, // Vino / L
        51650386559271: 54010090881362, // Vino / XL
        51650386592039: 54010090914130, // Vino / 2XL
        51650386624807: 54010090946898, // Vino / 3XL
      },
    },
    white2: {
      domain: 'https://white2.myshopify.com',
      // TODO: substituir pelos IDs reais da white2
      variants: {
        51547079016743: 92000000000001, // Home - Blue, XS
        51547079835943: 92000000000002, // Home - Blue, S
        51547079868711: 92000000000003, // Home - Blue, M
        51547079901479: 92000000000004, // Home - Blue, L
        51547079934247: 92000000000005, // Home - Blue, XL
        51547079967015: 92000000000006, // Home - Blue, 2XL
        51547079999783: 92000000000007, // Home - Blue, 3XL
        51547079049511: 92000000000008, // Away - Green, XS
        51547080032551: 92000000000009, // Away - Green, S
        51547080065319: 92000000000010, // Away - Green, M
        51547080098087: 92000000000011, // Away - Green, L
        51547080130855: 92000000000012, // Away - Green, XL
        51547080163623: 92000000000013, // Away - Green, 2XL
        51547080196391: 92000000000014, // Away - Green, 3XL
      },
    },
    white3: {
      domain: 'https://white3.myshopify.com',
      // TODO: substituir pelos IDs reais da white3
      variants: {
        51547079016743: 93000000000001, // Home - Blue, XS
        51547079835943: 93000000000002, // Home - Blue, S
        51547079868711: 93000000000003, // Home - Blue, M
        51547079901479: 93000000000004, // Home - Blue, L
        51547079934247: 93000000000005, // Home - Blue, XL
        51547079967015: 93000000000006, // Home - Blue, 2XL
        51547079999783: 93000000000007, // Home - Blue, 3XL
        51547079049511: 93000000000008, // Away - Green, XS
        51547080032551: 93000000000009, // Away - Green, S
        51547080065319: 93000000000010, // Away - Green, M
        51547080098087: 93000000000011, // Away - Green, L
        51547080130855: 93000000000012, // Away - Green, XL
        51547080163623: 93000000000013, // Away - Green, 2XL
        51547080196391: 93000000000014, // Away - Green, 3XL
      },
    },
  };

  var ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
  ];

  function getActiveStore() {
    return WHITE_STORES[ACTIVE_WHITE] || null;
  }

  /**
   * @param {string} url
   * @returns {string}
   */
  function appendAttributionParams(url) {
    if (!url || !window.location || !window.location.search) {
      return url;
    }

    var current = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();
    var hasAny = false;

    for (var i = 0; i < ATTRIBUTION_KEYS.length; i++) {
      var key = ATTRIBUTION_KEYS[i];
      var value = current.get(key);
      if (value) {
        out.set(key, value);
        hasAny = true;
      }
    }

    if (!hasAny) {
      return url;
    }

    var qs = out.toString();
    return url + (url.indexOf('?') === -1 ? '?' : '&') + qs;
  }

  /**
   * @param {{ items?: Array<{ id?: number, variant_id?: number, quantity?: number }> }} cart
   * @returns {string|null}
   */
  function buildWhiteCartUrl(cart) {
    var store = getActiveStore();
    if (!store || !cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return null;
    }

    var parts = [];
    var variants = store.variants;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var blackId = item.variant_id != null ? item.variant_id : item.id;
      var whiteId = variants[blackId];

      if (whiteId == null) {
        continue;
      }

      var qty = item.quantity != null ? item.quantity : 1;
      parts.push(whiteId + ':' + qty);
    }

    if (parts.length === 0) {
      return null;
    }

    return store.domain + '/cart/' + parts.join(',');
  }

  async function handleCheckoutClick(event) {
    var btn = event.target.closest('.adev-btn[name="checkout"]');
    if (!btn) return;

    var form = btn.closest('[data-adev-cart-drawer-form]');
    if (!form || form.tagName !== 'FORM') return;

    event.preventDefault();
    event.stopPropagation();

    try {
      var response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        return;
      }

      var cart = await response.json();
      var url = buildWhiteCartUrl(cart);

      if (url) {
        window.location.assign(appendAttributionParams(url));
      }
    } catch (err) {
      // No redirect on failure; leave drawer open.
    }
  }

  document.addEventListener('click', handleCheckoutClick, true);

  // Expose for manual / console verification
  window.adevWhiteCheckout = {
    ACTIVE_WHITE: ACTIVE_WHITE,
    WHITE_STORES: WHITE_STORES,
    getActiveStore: getActiveStore,
    buildWhiteCartUrl: buildWhiteCartUrl,
    appendAttributionParams: appendAttributionParams,
  };
})();
